import { useEffect, useRef, useState } from 'react'
import Loader from '@/components/loaders/Loader'
import TextLoading from '../ui/textLoading'

const LoadingScreen = ({ messages = [] }: { messages?: string[] }) => {
  const [index, setIndex] = useState(0)
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  useEffect(() => {
    if (messages.length === 0) return

    intervalRef.current = setInterval(() => {
      setIndex((prev) => (prev >= messages.length - 1 ? prev : prev + 1))
    }, 3000)

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current)
    }
  }, [messages])

  return (
    <div className="bg-background flex items-center justify-center h-screen">
      <div className="flex flex-col items-center justify-center">
        <Loader />
        <h1 className="text-gray-800 dark:text-white text-center font-bold text-xl pt-24">
          {messages.length > 0 && <TextLoading text={messages[index]} />}
        </h1>
      </div>
    </div>
  )
}

export default LoadingScreen
